import { render, staticRenderFns } from "./HeadcountCard.vue?vue&type=template&id=71148bd0"
import script from "./HeadcountCard.vue?vue&type=script&lang=js"
export * from "./HeadcountCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports